import { useTheme } from '@mui/material';
import { FinalGridContainer, FinalGridItem } from '@portals/core/src/components/FinalGrid/FinalGrid';
import { Typography } from '@portals/core/src/components/Typography/Typography';
import type { Theme } from '@portals/core/src/themes/themes';
import React from 'react';

import {
  InternHeadline,
  InternIcon,
  LinkActionLink,
  LinkAssetLink,
  LinkExternalLink,
  LinkInternalLink,
  LinkThematischerLink,
} from '../../../../models';
import { useLinkProps } from '../../../hooks/useLinkProps';
import { getStyles } from './LegalFooterLink.styles';

interface Props {
  node: {
    __component: 'intern.icon-link';
    id: string;
    link?: (LinkInternalLink | LinkExternalLink | LinkThematischerLink | LinkActionLink | LinkAssetLink)[];
    icon?: InternIcon;
    headline?: InternHeadline;
    text?: string;
  };
}

export const LegalFooterLink: React.FunctionComponent<Props> = ({ node }: Props) => {
  const { linkProps, anchorProps } = useLinkProps(node.link && node.link[0]);
  const theme = useTheme<Theme>();
  const styles = getStyles(theme);

  return (
    <FinalGridContainer
      columnGap={0}
      rowGap={0}
      sx={styles.container}
      component="li"
      data-select={`legal-footer-item.${node.id}`}
    >
      <FinalGridItem md={12} lg={12} innerPadding="both" {...linkProps}>
        <Typography variant="button" {...anchorProps} sx={styles.text}>
          {node.link && node.link[0]?.text}
        </Typography>
      </FinalGridItem>
    </FinalGridContainer>
  );
};
